export const alertServices = {
    default: "Es necesario completar este campo para poder avanzar",
    invalidPhoneNumber: {
        title: "N° de telefono Invalido",
        text: "El mismo no debe contener 0 ni 15. Ejemplo: 3815241384",
    },
    resolution: "El Campo Resolución es requerido para cerrar una llamada",
    asunto: "El Campo ASUNTO es requerido",

}